import { useEffect, useState } from "react";
import { checkLinkPlayable } from "../utils/linkPlayable.js";

// Playing status of a "Web Page" stream link for the Stream Health card: the same check
// Go Live runs (checkLinkPlayable - can a viewer's player open the link?), on mount / link
// change and again every 30s. The same shape as useStreamPlayback, so the card reads both
// the same way: { playing: true | false | null (checking), reason, confirmedAt }.
// No url = no checking at all.
const RECHECK_MS = 30000;
const NO_URL = Object.freeze({ playing: null, reason: "no-url", confirmedAt: null });
const CHECKING = Object.freeze({ playing: null, reason: "checking", confirmedAt: null });

export default function useLinkPlayable(url) {
  // The latest answer, tagged with the url it is for - a new url reads as "checking"
  // until its own first answer lands.
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!url) return undefined;
    let cancelled = false;
    let timer;
    let lastConfirmedAt = null;
    const check = async () => {
      const { playable, reason } = await checkLinkPlayable(url);
      if (cancelled) return;
      if (playable) lastConfirmedAt = Date.now();
      setResult({ url, state: { playing: playable, reason, confirmedAt: lastConfirmedAt } });
      timer = setTimeout(check, RECHECK_MS);
    };
    check();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [url]);

  if (!url) return NO_URL;
  if (result?.url !== url) return CHECKING;
  return result.state;
}
